<template>
  <div>
    <div class="container mx-auto h-auto laptop:h-almostscreen flex-col flex md:justify-center laptop:min-700 fullhd:min-900 min-h-0">
      <div class="z-10 md:p-5 laptop:p-0 px-5">
        <MARSHeading>
          <div v-html="$t('services.hero')" />
        </MARSHeading>
        <ActionButton bg="highlight" route="contacts" margin-top="mt-12" :value="$t('services.cta')" />
        <div class=" w-16 h-16 hidden laptop:block absolute bottom-0 mb-6 left-1/2 -ml-8 z-20">
          <img loading="lazy" class="mx-auto" src="~/assets/img/scroll-down-gif.gif" alt="Scroll down indicator">
        </div>
      </div>
    </div>

    <div class="container mx-auto flex flex-col laptop:flex-row pt-24 md:pt-32">
      <div class="
          laptop:w-6/12
          p-5
          md:p-0
          laptop:pl-0 laptop:mx-24
          md:mx-8 md:w-5/6
        ">
        <MARSTitle><div v-html="$t('services.model')" /></MARSTitle>

        <p class="text-standard laptop:text-slg md:text-base leading-7" v-html="$t('services.model-text-1')" />
        <p class="text-standard laptop:text-slg md:text-base leading-7" v-html="$t('services.model-text-2')" />
        <p class="text-standard laptop:text-slg md:text-base leading-7" v-html="$t('services.model-text-3')" />

        <ActionButton bg="highlight" route="contacts" margin-top="mt-5" margin-top-fullhd="fullhd:mt-10"
                      margin-top-laptop="laptop:mt-5" margin-top-tablet="md:mt-5" :value="$t('services.cta')" />
      </div>

      <div class="laptop:w-5/12 p-5 md:p-0 laptop:pl-0 laptop:mr-24 md:mx-8 md:w-5/6 mt-8 laptop:mt-0">
        <div class="grid grid-cols-1 gap-x-8 gap-y-16 h-full md:text-slg">
          <div class="flex items-center">
            <img loading="lazy" src="~/assets/img/ico-lens.svg">
            <b class="ml-8" v-html="$t('services.model-text-4')" />
          </div>
          <div class="flex items-center">
            <img loading="lazy" src="~/assets/img/ico-export.svg">
            <b class="ml-8" v-html="$t('services.model-text-5')" />
          </div>
          <div class="flex items-center">
            <img loading="lazy" src="~/assets/img/ico-materials.svg">
            <b class="ml-8" v-html="$t('services.model-text-6')" />
          </div>
          <div class="flex items-center">
            <img loading="lazy" src="~/assets/img/ico-distribution.svg">
            <b class="ml-8" v-html="$t('services.model-text-7')" />
          </div>
        </div>
      </div>
    </div>
    <div class="container mx-auto flex flex-col laptop:flex-row mt-12">
      <div class="w-11/12 mx-auto lg:px-8">
        <div class="w-full grid grid-cols-1 lg:grid-cols-3 gap-3">
          <img loading="lazy" src="~/assets/img/services-3d-01.webp">
          <img loading="lazy" src="~/assets/img/services-3d-02.webp">
          <img loading="lazy" src="~/assets/img/services-3d-03.webp">
        </div>
      </div>
    </div>

    <!-- Something something -->

    <div class="container mx-auto flex flex-col laptop:flex-row laptop:mt-150px pt-24 md:pt-32 pb-24">
      <div class="laptop:w-6/12 p-5 md:p-0 laptop:pl-0 laptop:mx-24 md:mx-8 md:w-5/6">
        <MARSTitle><div v-html="$t('services.scan')" /></MARSTitle>
        <ActionButton bg="highlight" route="contacts" margin-top="mt-5" margin-top-fullhd="fullhd:mt-0"
                      margin-top-laptop="laptop:mt-5" margin-top-tablet="md:mt-5" :value="$t('services.cta')" />
      </div>
      <div class="laptop:w-5/12 p-5 md:p-0 laptop:pl-0 laptop:mr-24 md:mx-8 md:w-5/6 mt-8 laptop:mt-4 mb-12 laptop:mb-24">
        <p class="text-standard laptop:text-slg md:text-base leading-7" v-html="$t('services.scan-text-1')" />
        <p class="text-standard laptop:text-slg md:text-base leading-7 py-8" v-html="$t('services.scan-text-2')" />
        <p class="text-standard laptop:text-slg md:text-base leading-7" v-html="$t('services.scan-text-3')" />
      </div>
    </div>
    <div class="container mx-auto flex flex-col laptop:flex-row py-12 laptop:mt-150px gap-8">
      <div class="w-full flex laptop:w-1/2 p-5 laptop:h-auto h-video md:p-0 md:px-8 order-last laptop:order-first" style="min-height: 390px;">
        <iframe v-if="youtubeEnabled && $i18n.locale != 'it'" width="100%" height="100%"
                src="https://www.youtube.com/embed/8ZyDiA5HZ3Q?rel=0" frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen />
        <iframe v-if="youtubeEnabled && $i18n.locale == 'it'" width="100%" height="100%"
                src="https://www.youtube.com/embed/eX7pozUqfZo?rel=0" frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen />

        <iframe v-if="!youtubeEnabled && $i18n.locale != 'it'" width="100%" height="100%"
                src="https://www.youtube-nocookie.com/embed/8ZyDiA5HZ3Q?rel=0" frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen />
        <iframe v-if="!youtubeEnabled && $i18n.locale == 'it'" width="100%" height="100%"
                src="https://www.youtube-nocookie.com/embed/eX7pozUqfZo?rel=0" frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen />
      </div>
      <div class="w-full flex laptop:w-1/2 p-5 flex-col laptop:justify-around order-first laptop:order-last">
        <div>
          <h2 class="font-bold md:w-full mb-4 text-standard md:text-45xl lg:text-45xl laptop:text-55xl" v-html="$t('services.photogrammetry')" />
          <p v-html="$t('services.photogrammetry-text')" />
          <ActionButton :href="$t('services.youtube-link')" :value="$t('services.youtube')" />
        </div>
      </div>
    </div>
    <div class="mt-150px" />
  </div>
</template>

<script setup lang="ts">
import { useIubenda } from 'mars-iubenda-vite';

const {youtubeEnabled} = useIubenda()
</script>

<style scoped></style>
